<template>
  <v-dialog v-model="show" width="785px" persistent>
    <div class="modal" style="height: auto;">
      <v-card flat>
        <v-row style="min-height: 280px;">
          <div class="icon-modal table-cell" style="height: auto; display: flex; flex-direction: column; align-items: center; justify-content: center; padding-top: 24px; padding-bottom: 24px;">
            <div
              v-if="show_options"
              @click="goToSignupWaitlist"
              style="width: calc(100% - 24px); margin: 0 12px 16px; background: rgba(255,255,255,0.25); border-radius: 8px; padding: 10px 8px; text-align: center; cursor: pointer; transition: background 0.15s;"
              @mouseenter="$event.currentTarget.style.background='rgba(255,255,255,0.4)'"
              @mouseleave="$event.currentTarget.style.background='rgba(255,255,255,0.25)'"
            >
              <span style="color: #fff; font-size: 13px; font-weight: 700; letter-spacing: 0.02em; line-height: 1.3; white-space: nowrap;">Waitlist</span>
            </div>
            <v-layout class="delete-warning-icon" style="flex: 0 0 auto;">
              <v-flex>
                <img :src="require('@/assets/img/kiey-icon.svg')" alt="" style="width: 120px; height: 140px;"/>
              </v-flex>
            </v-layout>
            <div v-if="show_options" style="margin-top: 32px; display: flex; flex-direction: column; gap: 12px; width: 100%; padding: 0 12px;">
              <div
                @click="goToUserConsent"
                style="background: rgba(255,255,255,0.25); border-radius: 8px; padding: 10px 8px; text-align: center; cursor: pointer; transition: background 0.15s;"
                @mouseenter="$event.target.style.background='rgba(255,255,255,0.4)'"
                @mouseleave="$event.target.style.background='rgba(255,255,255,0.25)'"
              >
                <span style="color: #fff; font-size: 13px; font-weight: 700; letter-spacing: 0.02em; line-height: 1.3; white-space: nowrap;">Users &amp; Consent</span>
              </div>
              <div
                @click="goToBusinessLogic"
                style="background: rgba(255,255,255,0.25); border-radius: 8px; padding: 10px 8px; text-align: center; cursor: pointer; transition: background 0.15s;"
                @mouseenter="$event.target.style.background='rgba(255,255,255,0.4)'"
                @mouseleave="$event.target.style.background='rgba(255,255,255,0.25)'"
              >
                <span style="color: #fff; font-size: 13px; font-weight: 700; letter-spacing: 0.02em; line-height: 1.3; display: block;">Logic</span>
              </div>
              <div
                @click="goToAppVersions"
                style="background: rgba(255,255,255,0.25); border-radius: 8px; padding: 10px 8px; text-align: center; cursor: pointer; transition: background 0.15s;"
                @mouseenter="$event.target.style.background='rgba(255,255,255,0.4)'"
                @mouseleave="$event.target.style.background='rgba(255,255,255,0.25)'"
              >
                <span style="color: #fff; font-size: 13px; font-weight: 700; letter-spacing: 0.02em; line-height: 1.3; white-space: nowrap;">App Versions</span>
              </div>
              <div
                @click="goToInvitedUsersAll"
                style="background: rgba(255,255,255,0.25); border-radius: 8px; padding: 10px 8px; text-align: center; cursor: pointer; transition: background 0.15s;"
                @mouseenter="$event.target.style.background='rgba(255,255,255,0.4)'"
                @mouseleave="$event.target.style.background='rgba(255,255,255,0.25)'"
              >
                <span style="color: #fff; font-size: 13px; font-weight: 700; letter-spacing: 0.02em; line-height: 1.3; white-space: nowrap;">Invited Users</span>
              </div>
              <div
                @click="goToTenants"
                style="background: rgba(255,255,255,0.25); border-radius: 8px; padding: 10px 8px; text-align: center; cursor: pointer; transition: background 0.15s;"
                @mouseenter="$event.target.style.background='rgba(255,255,255,0.4)'"
                @mouseleave="$event.target.style.background='rgba(255,255,255,0.25)'"
              >
                <span style="color: #fff; font-size: 13px; font-weight: 700; letter-spacing: 0.02em; line-height: 1.3; white-space: nowrap;">Tenants</span>
              </div>
              <div
                @click="goToMarkets"
                style="background: rgba(255,255,255,0.25); border-radius: 8px; padding: 10px 8px; text-align: center; cursor: pointer; transition: background 0.15s;"
                @mouseenter="$event.target.style.background='rgba(255,255,255,0.4)'"
                @mouseleave="$event.target.style.background='rgba(255,255,255,0.25)'"
              >
                <span style="color: #fff; font-size: 13px; font-weight: 700; letter-spacing: 0.02em; line-height: 1.3; white-space: nowrap;">Markets</span>
              </div>
              <div
                @click="goToMarketingConsole"
                style="background: rgba(255,255,255,0.25); border-radius: 8px; padding: 10px 8px; text-align: center; cursor: pointer; transition: background 0.15s;"
                @mouseenter="$event.target.style.background='rgba(255,255,255,0.4)'"
                @mouseleave="$event.target.style.background='rgba(255,255,255,0.25)'"
              >
                <span style="color: #fff; font-size: 13px; font-weight: 700; letter-spacing: 0.02em; line-height: 1.3; white-space: nowrap;">Marketing Console</span>
              </div>
              <div
                @click="goToDeployment"
                style="background: rgba(255,255,255,0.25); border-radius: 8px; padding: 10px 8px; text-align: center; cursor: pointer; transition: background 0.15s;"
                @mouseenter="$event.target.style.background='rgba(255,255,255,0.4)'"
                @mouseleave="$event.target.style.background='rgba(255,255,255,0.25)'"
              >
                <span style="color: #fff; font-size: 13px; font-weight: 700; letter-spacing: 0.02em; line-height: 1.3; white-space: nowrap;">Onboarding</span>
              </div>
            </div>
          </div>
          <v-col class="table-cell modal-content" style="padding: 20px 43px 20px 30px !important; display: flex; flex-direction: column; justify-content: center;">
            <div class="d-flex justify-space-between align-center" style="width: 100%; gap: 16px;">
              <div class="d-flex align-center" style="gap: 10px;">
                <button
                  type="button"
                  @click="goBackToLogin"
                  aria-label="Back to login"
                  style="flex-shrink: 0; width: 32px; height: 32px; border-radius: 50%; border: 1px solid #dbe3f0; background: #fff; display: flex; align-items: center; justify-content: center; cursor: pointer; color: #29ABE2; padding: 0; transition: background 160ms ease, border-color 160ms ease;"
                  onmouseover="this.style.background='#f5f9ff'; this.style.borderColor='#afc2eb';"
                  onmouseout="this.style.background='#fff'; this.style.borderColor='#dbe3f0';"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                </button>
                <h6 class="modal-title mb-0" style="margin: 0; line-height: 1;">Welcome{{ options.first_name ? ' ' + options.first_name + ',' : '' }}</h6>
              </div>
              <p v-if="show_options" style="font-size: 13px; font-weight: 600; margin: 0; text-align: right; white-space: nowrap;">
                <span style="color: #061d47;">Total: {{ total_agents_active + total_agents_inactive + total_vendors_active + total_vendors_inactive + total_users_active + total_users_inactive }}</span>
                <span style="color: #ccc; margin: 0 6px;">|</span>
                <span style="color: #29ABE2;">Active: {{ total_agents_active + total_vendors_active + total_users_active }}</span>
                <span style="color: #ccc; margin: 0 6px;">|</span>
                <span style="color: #888;">Inactive: {{ total_agents_inactive + total_vendors_inactive + total_users_inactive }}</span>
              </p>
            </div>
            <!--<p style="position: relative;-->
            <!--top: -4px;line-height: 14px !important;"></p>-->

            <div class="mt-3" v-if="!show_options">
            </div>

            <div class="custom-select-margin" v-if="!show_options">
              <v-autocomplete
                  v-if="options"
                  :items="newOptions"
                  v-model="selectedTenantUser"
                  item-text="company_role"
                  item-value="id"
                  class="label-custom mt-0 pt-0 mr-3 pr-3 custom-input-position-text change_bord especial_border custom-select-options"
                  name="type"
                  type="text"
                  placeholder="Select a company"
                  style="margin-right: 7px"
                  :multiple="false"
                  required
              >
                <template v-slot:append>
                  <img :src="require('@/assets/img/dropdown-blue.svg')" alt/>
                </template>
              </v-autocomplete>
            </div>

            <div v-if="show_options">
              <div class="mt-3">
                <label style="position: relative;
    top: -4px;">Please select a company: (Total {{total_company}})</label>
              </div>

              <div class="custom-select-margin">
                <v-autocomplete
                    :items="options_company"
                    v-model="selectedTenantAll"
                    item-text="company_name"
                    item-value="tenant_id"
                    class="label-custom mt-0 pt-0 mr-3 pr-3 custom-input-position-text change_bord especial_border custom-select-options"
                    name="type"
                    type="text"
                    placeholder="Select a Company:"
                    style="margin-right: 7px"
                    :multiple="false"
                    @change="updateSelected('company')"
                    required
                >
                  <template v-slot:append>
                    <img :src="require('@/assets/img/dropdown-blue.svg')" alt/>
                  </template>
                </v-autocomplete>
              </div>

              <div class="mt-3">
                <label style="position: relative; top: -4px;">Please select an Agent: <span v-for="(count, status) in agents_by_status" :key="'ag-' + status" style="margin-right: 4px;">({{ status }} {{ count }})</span></label>
              </div>

              <div class="custom-select-margin">
                <v-autocomplete
                    :items="options_agents"
                    v-model="selectedTenantAgent"
                    item-text="company_name"
                    item-value="tenant_id"
                    class="label-custom mt-0 pt-0 mr-3 pr-3 custom-input-position-text change_bord especial_border custom-select-options"
                    name="type"
                    type="text"
                    placeholder="Select an Agent:"
                    style="margin-right: 7px"
                    :multiple="false"
                    @change="updateSelected('agent')"
                    required
                >
                  <template v-slot:append>
                    <img :src="require('@/assets/img/dropdown-blue.svg')" alt/>
                  </template>
                </v-autocomplete>
              </div>

              <div class="mt-3">
                <label style="position: relative; top: -4px;">Please select a Vendor: <span v-for="(count, status) in vendors_by_status" :key="'vn-' + status" style="margin-right: 4px;">({{ status }} {{ count }})</span></label>
              </div>

              <div class="custom-select-margin">
                <v-autocomplete
                    :items="options_vendors"
                    v-model="selectedTenantVendor"
                    item-text="company_name"
                    item-value="tenant_id"
                    class="label-custom mt-0 pt-0 mr-3 pr-3 custom-input-position-text change_bord especial_border custom-select-options"
                    name="type"
                    type="text"
                    placeholder="Select a Vendor:"
                    style="margin-right: 7px"
                    :multiple="false"
                    @change="updateSelected('vendor')"
                    required
                >
                  <template v-slot:append>
                    <img :src="require('@/assets/img/dropdown-blue.svg')" alt/>
                  </template>
                </v-autocomplete>
              </div>

              <div class="mt-3">
                <label style="position: relative; top: -4px;">Please search for a Homeowner: <span v-for="(count, status) in clients_by_status" :key="'cl-' + status" style="margin-right: 4px;">({{ status }} {{ count }})</span></label>
              </div>

              <div class="custom-select-margin">
                <v-autocomplete
                    :items="options_users"
                    v-model="selectedTenantUserAll"
                    item-text="company_name"
                    item-value="owner_id"
                    class="label-custom mt-0 pt-0 mr-3 pr-3 custom-input-position-text change_bord especial_border custom-select-options"
                    name="type"
                    type="text"
                    placeholder="Search for a Homeowner:"
                    style="margin-right: 7px"
                    :multiple="false"
                    @change="updateSelected('user')"
                    required
                >
                  <template v-slot:append>
                    <img :src="require('@/assets/img/dropdown-blue.svg')" alt/>
                  </template>
                </v-autocomplete>
              </div>
            </div>

            <div class="mt-3 mb-5 buttons d-flex" v-if="!show_options">
              <v-btn
                  class="btn-blanco few mt-2 mr-6"
                  rounded
                  depressed
                  @click="submit"
                  style="width:160px;position: relative;left: -1px;"
              >Login
              </v-btn>
            </div>
            <div class="mt-3 mb-5 buttons d-flex" v-if="show_options">
              <v-btn
                  class="btn-blanco few mt-2 mr-6"
                  rounded
                  depressed
                  @click="submitSuperUser"
                  style="width:160px;position: relative;left: -1px;"
              >Login
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </div>
  </v-dialog>
</template>
<script>
  import {mapState, mapActions} from "vuex";

  export default {
    props: {
      show: {
        type: Boolean,
        default: false
      },
      onInactive: {
        type: Function,
        default: () => {
        }
      },
      onError: {
        type: Function,
        default: () => {
        }
      }
    },
    components: {},
    watch: {
      show(val) {
        if(val) {
          this.$store.commit('Authenticate/status', '');
        }
      }
    },
    data() {
      return {
        selectedTenantUser: null,
        selectedTenantAgent: null,
        selectedTenantVendor: null,
        selectedTenantUserAll: null,
        selectedTenantAll: null,
        newOptions: [],
        user: null,
        show_options: false,
        dataToSend: {
          user_id: null,
          tenant_id: null,
          user_role: null
        }
      }
    },
    created() {

    },
    mounted() {
      this.user = this.options;
      if (this.user.is_system_super_user === true) {
        this.show_options = true;
        this.get_options();
        localStorage.setItem('is_super_user', 'true');
      } else {
        localStorage.removeItem('is_super_user');
        for (const prop in this.options.tenants_list) {

          // let checkRecord = this.newOptions.find(x => x.tenant_id === this.options.tenants_list[prop]['tenant_id']);
          // if (!checkRecord) {
          this.newOptions.push({
            ...this.options.tenants_list[prop],
            id: prop,
            //company_role: this.options.tenants_list[prop]['company_name'] + " | " + (this.options.tenants_list[prop]['role']).toUpperCase()
            company_role: `${this.options.tenants_list[prop]['company_name']}`
          })
          // }
        }
      }
//    this.selectedTenantUser = this.newOptions[0].id;
    },
    computed: {
      ...mapState({
        options: state => state.Authenticate.options,
        user_tmp: state => state.Authenticate.user_tmp,
        options_company: state => state.Authenticate.options_company,
        options_agents: state => state.Authenticate.options_agents,
        options_vendors: state => state.Authenticate.options_vendors,
        options_users: state => state.Authenticate.options_users,
        total_users: state => state.Authenticate.total_users,
        total_agents: state => state.Authenticate.total_agents,
        total_vendors: state => state.Authenticate.total_vendors,
        total_company: state => state.Authenticate.total_company,
        total_agents_active: state => state.Authenticate.total_agents_active,
        total_agents_inactive: state => state.Authenticate.total_agents_inactive,
        total_vendors_active: state => state.Authenticate.total_vendors_active,
        total_vendors_inactive: state => state.Authenticate.total_vendors_inactive,
        total_users_active: state => state.Authenticate.total_users_active,
        total_users_inactive: state => state.Authenticate.total_users_inactive,
        agents_by_status: state => state.Authenticate.agents_by_status,
        vendors_by_status: state => state.Authenticate.vendors_by_status,
        clients_by_status: state => state.Authenticate.clients_by_status

      })
    },
    methods:
      {
        ...
          mapActions({
            get_options: "Authenticate/get_options"
          }),
        submit: function () {
          const self = this;

          let dataToSend = {
            "user_id": self.options.phone_number,
            "tenant_id": self.newOptions[self.selectedTenantUser]['tenant_id'],
            "user_role": self.newOptions[self.selectedTenantUser]['role'],
          };

          let inactiveAccontExist = Object.values(this.user_tmp.tenants_list)
            .find(
              x => x.tenant_id === self.newOptions[self.selectedTenantUser]['tenant_id'] &&
                x.role !== self.newOptions[self.selectedTenantUser]['role'] &&
                x.status === 'inactive'
            );

          if (inactiveAccontExist) {
            self.onInactive({inactive: inactiveAccontExist, active: self.newOptions[self.selectedTenantUser]});
          } else {
            self.$store.dispatch('Authenticate/activate_ut', dataToSend).catch(error => {
              self.onError(error);
            });
          }
        },
        onSelectTenant(tenant) {
          const self = this;

          let dataToSend = {
            "user_id": self.options.phone_number,
            "tenant_id": tenant.tenant_id,
            "user_role": tenant.role,
          };

          self.$store.dispatch('Authenticate/activate_ut', dataToSend).catch(error => {
            self.onError(error);
          });
        },
        updateSelected(type) {
          if (type === 'company') {
            this.selectedTenantAgent = null;
            this.selectedTenantVendor = null;
            this.selectedTenantUserAll = null;
            this.dataToSend.tenant_id = this.selectedTenantAll.split('-')[0];
            this.dataToSend.user_role = this.selectedTenantAll.split('-')[1];
            this.dataToSend.user_id = this.selectedTenantAll.split('-')[2]

          }

          if (type === 'agent') {
            this.selectedTenantVendor = null;
            this.selectedTenantUserAll = null;
            this.selectedTenantAll = null;
            this.dataToSend.tenant_id = this.selectedTenantAgent.split('-')[0];
            this.dataToSend.user_role = null; // server resolves role from Firestore
            this.dataToSend.user_id = this.selectedTenantAgent.split('-')[2]
          }

          if (type === 'vendor') {
            this.selectedTenantAgent = null;
            this.selectedTenantUserAll = null;
            this.selectedTenantAll = null;
            this.selectedTenantUser = this.selectedTenantVendor
            this.dataToSend.tenant_id = this.selectedTenantVendor.split('-')[0];
            this.dataToSend.user_role = 'vendor';
            this.dataToSend.user_id = this.selectedTenantVendor.split('-')[2]
          }

          if (type === 'user') {
            this.selectedTenantAgent = null;
            this.selectedTenantVendor = null;
            this.selectedTenantAll = null;
            this.dataToSend.tenant_id = this.selectedTenantUserAll.split('-')[1];
            this.dataToSend.user_role = this.selectedTenantUserAll.split('-')[2];
            this.dataToSend.user_id = this.selectedTenantUserAll.split('-')[3];
          }
        },
        submitSuperUser() {
          const self = this;
          // Backup the super_user's options (tenant data) before aliasing.
          // state.user / state.token aren't populated until activate_ut's
          // auth_success fires, so we can't back them up here — but we don't
          // need to: when the user picks a tenant from the restored modal,
          // activate_ut re-uses the live Firebase session to mint a new token.
          const authState = self.$store.state.Authenticate;
          try {
            if (authState.options && authState.options.is_system_super_user) {
              localStorage.setItem('super_user_return', JSON.stringify({
                options: authState.options,
              }));
            }
          } catch (e) {
            // localStorage might be full / disabled — not fatal, back button just won't appear
          }
          self.$store.dispatch('Authenticate/activate_ut', self.dataToSend).catch(error => {
            self.onError(error);
          });
        },
        goToUserConsent() {
          this.$emit('show-sms-logs');
          this.$nextTick(() => {
            this.$store.commit('Authenticate/state_modal', false);
            document.querySelectorAll('.v-overlay').forEach(el => el.remove());
            document.documentElement.style.overflow = '';
          });
        },
        goToBusinessLogic() {
          this.$emit('show-business-logic');
          this.$nextTick(() => {
            this.$store.commit('Authenticate/state_modal', false);
            document.querySelectorAll('.v-overlay').forEach(el => el.remove());
            document.documentElement.style.overflow = '';
          });
        },
        goToAppVersions() {
          this.$emit('show-app-versions');
          this.$nextTick(() => {
            this.$store.commit('Authenticate/state_modal', false);
            document.querySelectorAll('.v-overlay').forEach(el => el.remove());
            document.documentElement.style.overflow = '';
          });
        },
        goToInvitedUsersAll() {
          this.$emit('show-invited-users-all');
          this.$nextTick(() => {
            this.$store.commit('Authenticate/state_modal', false);
            document.querySelectorAll('.v-overlay').forEach(el => el.remove());
            document.documentElement.style.overflow = '';
          });
        },
        goToTenants() {
          this.$emit('show-tenants');
          this.$nextTick(() => {
            this.$store.commit('Authenticate/state_modal', false);
            document.querySelectorAll('.v-overlay').forEach(el => el.remove());
            document.documentElement.style.overflow = '';
          });
        },
        goToMarkets() {
          this.$emit('show-markets');
          this.$nextTick(() => {
            this.$store.commit('Authenticate/state_modal', false);
            document.querySelectorAll('.v-overlay').forEach(el => el.remove());
            document.documentElement.style.overflow = '';
          });
        },
        goToMarketingConsole() {
          this.$emit('show-marketing-console');
          this.$nextTick(() => {
            this.$store.commit('Authenticate/state_modal', false);
            document.querySelectorAll('.v-overlay').forEach(el => el.remove());
            document.documentElement.style.overflow = '';
          });
        },
        goToDeployment() {
          this.$emit('show-onboarding');
          this.$nextTick(() => {
            this.$store.commit('Authenticate/state_modal', false);
            document.querySelectorAll('.v-overlay').forEach(el => el.remove());
            document.documentElement.style.overflow = '';
          });
        },
        goToSignupWaitlist() {
          this.$emit('show-signup-waitlist');
          this.$nextTick(() => {
            this.$store.commit('Authenticate/state_modal', false);
            document.querySelectorAll('.v-overlay').forEach(el => el.remove());
            document.documentElement.style.overflow = '';
          });
        },
        goBackToLogin() {
          // Clear any partial auth state and return to the phone-number login screen.
          // Dispatch (not commit) so the action's cross-store cleanups fire —
          // otherwise any partially-loaded tenant data carries forward into the
          // next login session (audit Item #6).
          this.$store.dispatch('Authenticate/safety_logout');
          this.$store.commit('Authenticate/state_modal', false);
          localStorage.removeItem('is_super_user');
          this.$nextTick(() => {
            document.querySelectorAll('.v-overlay').forEach(el => el.remove());
            document.documentElement.style.overflow = '';
          });
        },
      }
    ,
  };
</script>